export enum AmabAfabMedicalPreference {
  AMAB = "AMAB_PREF",
  AFAB = "AFAB_PREF",
  AUTO_SKIPPED = "AUTO_SKIPPED",
  DECLINE_MEDICAL_QUESTIONS = "DECLINED_HEALTH_QS",
  PREF_UNAVAILABLE_FOR_JOURNEY = "PREF_UNAVAILABLE_FOR_JOURNEY"
}

export enum MedicalQuestionsWorkflow {
  AMAB_MEDICAL_QUESTIONS = "AMAB",
  AFAB_MEDICAL_QUESTIONS = "AFAB",
  DECLINE_MEDICAL_QUESTIONS = "DECLINE",
  PREGNANCY_MEDICAL_QUESTIONS = "PREGNANCY",
  POSTPARTUM_MEDICAL_QUESTIONS = "POSTPARTUM"
}

export type MedicalFlowDetail = {
  journey: string
  amabAfabPreference: AmabAfabMedicalPreference
  workflow?: MedicalQuestionsWorkflow
}
